module.exports = __webpack_public_path__ + "static/media/hive-full-logo-gray.a6cb3203.svg";